var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDirection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "9px",
    viewBox: "0 0 51 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ArrowDirection") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-designs-current",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TP_DIY-PBA-GAP-1",
    transform: "translate(-1057.000000, -258.000000)",
    fill: "#C5C5C9",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1061.5,258 C1063.81638,258 1065.72398,259.750179 1065.97257,262.000297 L1065.97246,263.000707 C1065.72341,265.250342 1063.81603,267 1061.5,267 C1059.01472,267 1057,264.985281 1057,262.5 C1057,260.014719 1059.01472,258 1061.5,258 Z M1099,258 L1108,262.5 L1099,267 L1099,263 L1099,262 L1099,258 Z M1069.5,262 L1069.5,263 L1067.5,263 L1067.5,262 L1069.5,262 Z M1073.5,262 L1073.5,263 L1071.5,263 L1071.5,262 L1073.5,262 Z M1077.5,262 L1077.5,263 L1075.5,263 L1075.5,262 L1077.5,262 Z M1081.5,262 L1081.5,263 L1079.5,263 L1079.5,262 L1081.5,262 Z M1085.5,262 L1085.5,263 L1083.5,263 L1083.5,262 L1085.5,262 Z M1089.5,262 L1089.5,263 L1087.5,263 L1087.5,262 L1089.5,262 Z M1093.5,262 L1093.5,263 L1091.5,263 L1091.5,262 L1093.5,262 Z M1097.5,262 L1097.5,263 L1095.5,263 L1095.5,262 L1097.5,262 Z",
    id: "ArrowDirection-1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDirection);
export default __webpack_public_path__ + "static/media/ArrowDirection.ede24260.svg";
export { ForwardRef as ReactComponent };